export const BasicNeedsKeywords = {
  "label": "Basic Needs",
  "value": [
    {
      "code": "LH-5000.6750",
      "keyword": "Protective Equipment for Individuals With Medical Needs"
    },
    {
      "code": "YJ-8745",
      "keyword": "People With Complex Needs"
    },
    {
      "code": "NL-6000.2000",
      "keyword": "Food Stamps\/SNAP"
    },
    {
      "code": "NL-6000.9500",
      "keyword": "WIC"
    },
    {
      "code": "BD",
      "keyword": "Food"
    },
    {
      "code": "BD-1800",
      "keyword": "Emergency Food"
    },
    {
      "code": "BD-1800.1000",
      "keyword": "Brown Bag Food Programs"
    },
    {
      "code": "BD-1800.1500",
      "keyword": "Commodity Supplemental Food Program"
    },
    {
      "code": "BD-1800.1515",
      "keyword": "Community Fridges\/Food Cabinets"
    },
    {
      "code": "BD-1800.2000",
      "keyword": "Food Pantries"
    },
    {
      "code": "BD-1800.5000",
      "keyword": "Mobile Food Pantry Programs"
    },
    {
      "code": "BD-1800.8200-250",
      "keyword": "Formula\/Baby Food"
    },
    {
      "code": "BD-1875.2000",
      "keyword": "Food Banks\/Food Distribution Warehouses"
    },
    {
      "code": "BD-2400",
      "keyword": "Food Outlets"
    },
    {
      "code": "BD-2400.2250",
      "keyword": "Farmers Markets"
    },
    {
      "code": "BD-2400.2265",
      "keyword": "Farmers Markets Accepting Nutrition Program Vouchers"
    },
    {
      "code": "BD-2400.2500",
      "keyword": "Food Cooperatives"
    },
    {
      "code": "BD-2600.1500",
      "keyword": "Community Gardening"
    },
    {
      "code": "BD-2600.3000",
      "keyword": "Home Gardening Assistance\/Supplies"
    },
    {
      "code": "BD-5000",
      "keyword": "Meals"
    },
    {
      "code": "BD-5000.1500",
      "keyword": "Congregate Meals\/Nutrition Sites"
    },
    {
      "code": "BD-5000.3500",
      "keyword": "Home Delivered Meals"
    },
    {
      "code": "BD-5000.8050",
      "keyword": "School Closure Related Breakfast\/Lunch Services"
    },
    {
      "code": "BD-5000.8300",
      "keyword": "Soup Kitchens"
    },
    {
      "code": "BD-5000.8500",
      "keyword": "Summer Food Service Programs"
    },
    {
      "code": "BH",
      "keyword": "Housing\/Shelter"
    },
    {
      "code": "BH-0500",
      "keyword": "At Risk\/Homeless Housing Related Assistance Programs"
    },
    {
      "code": "BH-0500.3200",
      "keyword": "Housing Related Coordinated Assessment"
    },
    {
      "code": "BH-0500.3200-300",
      "keyword": "Housing Related Coordinated Entry Lead Agencies"
    },
    {
      "code": "BH-0500.3200-310",
      "keyword": "Housing Related Coordinated Entry Participating Agencies"
    },
    {
      "code": "BH-0500.7000",
      "keyword": "Rapid Re-Housing Programs"
    },
    {
      "code": "BH-1800",
      "keyword": "Emergency Shelter"
    },
    {
      "code": "BH-1800.1500-100",
      "keyword": "Domestic Violence Shelters"
    },
    {
      "code": "BH-1800.1500-960",
      "keyword": "Youth Shelters"
    },
    {
      "code": "BH-1800.3500",
      "keyword": "Homeless Drop In Centers"
    },
    {
      "code": "BH-1800.8500",
      "keyword": "Homeless Shelter"
    },
    {
      "code": "BH-1800.8500-185",
      "keyword": "Extreme Weather Shelters"
    },
    {
      "code": "BM",
      "keyword": "Material Goods"
    },
    {
      "code": "BM-0500",
      "keyword": "Automobiles"
    },
    {
      "code": "BM-3000",
      "keyword": "Household Goods"
    },
    {
      "code": "BM-3000.0500",
      "keyword": "Appliances"
    },
    {
      "code": "BM-3000.0500-030",
      "keyword": "Air Conditioners"
    },
    {
      "code": "BM-3000.0500-200",
      "keyword": "Fans"
    },
    {
      "code": "BM-3000.0500-350",
      "keyword": "Heaters"
    },
    {
      "code": "BM-3000.1000",
      "keyword": "Bedding\/Linen"
    },
    {
      "code": "BM-3000.2000",
      "keyword": "Furniture"
    },
    {
      "code": "BM-3000.2500",
      "keyword": "General Household Goods Provision"
    },
    {
      "code": "BM-3000.5000",
      "keyword": "Mattresses"
    },
    {
      "code": "BM-6500.1500-100",
      "keyword": "Baby Clothing"
    },
    {
      "code": "BM-6500.1500-150",
      "keyword": "Diapers"
    },
    {
      "code": "BM-6500.1500-250",
      "keyword": "Clothing - General"
    },
    {
      "code": "BM-6500.1500-500",
      "keyword": "Maternity Clothing"
    },
    {
      "code": "BM-6500.1500-800",
      "keyword": "School Clothing"
    },
    {
      "code": "BM-6500.1500-950",
      "keyword": "Work Clothing"
    },
    {
      "code": "BM-6500.6500-300",
      "keyword": "Hair and Nail Care"
    },
    {
      "code": "BM-6500.6500-450",
      "keyword": "Laundry Facilities"
    },
    {
      "code": "BM-6500.6500-650",
      "keyword": "Personal\/Grooming Supplies"
    },
    {
      "code": "BM-6500.6500-710",
      "keyword": "Public Showers\/Baths"
    },
    {
      "code": "NL-6000.2000",
      "keyword": "Food Stamps\/SNAP"
    },
    {
      "code": "NL-6000.9500",
      "keyword": "WIC"
    },
    {
      "code": "BH-7000.4600-280",
      "keyword": "Emergency Housing Voucher (EHV) Program"
    },
    {
      "code": "BH-7000.4600-300",
      "keyword": "Homeless Alternative Housing Developments"
    },
    {
      "code": "BH-7000.4600-450",
      "keyword": "Low Income\/Subsidized Private Rental Housing"
    },
    {
      "code": "BH-7000.4600-700",
      "keyword": "Section 8 Housing Choice Vouchers"
    },
    {
      "code": "BH-8300.3000",
      "keyword": "Housing Authorities"
    },
    {
      "code": "FT-1800.3000",
      "keyword": "Housing Discrimination Assistance"
    },
    {
      "code": "YV-3000",
      "keyword": "Homeless People"
    },
    {
      "code": "BH-8600",
      "keyword": "Transitional Housing\/Shelter"
    },
    {
      "code": "TI-1800.1500-180",
      "keyword": "Diaper Donation Programs"
    },
    {
      "code": "LH-0600.6500-950",
      "keyword": "Wigs"
    },
    {
      "code": "LH-2700.3000",
      "keyword": "Hygiene"
    },
    {
      "code": "LH-5000.5050",
      "keyword": "Menstruation Supplies"
    },
    {
      "code": "TH-2600.1880",
      "keyword": "Extreme Cold Warming Centers"
    },
    {
      "code": "TH-2600.1900-180",
      "keyword": "Extreme Heat Cooling Centers"
    },
    {
      "code": "TH-2600.1930",
      "keyword": "Extreme Heat Hydration Stations"
    },
  ]
}
